module.exports = __webpack_public_path__ + "media/src/img/uni/uniteller-8fb552fbdb362bb8871dba5ec704ac75.svg";